import { render, staticRenderFns } from "./PanelSuperVisor.vue?vue&type=template&id=54c35832&scoped=true"
import script from "./PanelSuperVisor.vue?vue&type=script&lang=js"
export * from "./PanelSuperVisor.vue?vue&type=script&lang=js"
import style0 from "./PanelSuperVisor.vue?vue&type=style&index=0&id=54c35832&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c35832",
  null
  
)

export default component.exports